import ApiService from '@/api';
import { ResponseModel } from '@/models';
import { CreateQueueModel } from '../models';
import { mapCreateQueueRequest } from './AdapterServiceMappers';

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Создать очередь
   * @param request
   * @returns
   */
  createQueue(request: CreateQueueModel) {
    return new Promise<ResponseModel<string>>(async (resolve) => {
      const result = new ResponseModel<string>();

      await this.api.Main.ProjectQueueTaskService.createAsync(mapCreateQueueRequest(request))
        .then((resp) => {
          result.Value = resp.Id;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR createQueue', e);
          return resolve(result);
        });
    });
  }
}
